<script setup lang="ts">
const articleCounts = useArticleReadCounts()

const cards = useArticleCards()

await cards.suspense()

const mostReadArticles = computed(() =>
  LEVELS.reduce(
    (acc, level) => {
      const counts = articleCounts.data.value?.counts ?? {}
      acc[level] =
        cards.data.value
          ?.filter((card) => card.levels.includes(level))
          .sort((a, b) => (counts[b.id] || 0) - (counts[a.id] || 0))
          .slice(0, 3) ?? []
      return acc
    },
    {} as Record<Level, ArticleCard[]>,
  ),
)

const hasData = computed(
  () => Object.values(mostReadArticles.value).flat().length > 0,
)
</script>

<template>
  <section v-if="hasData" class="relative bg-coral-20 pb-24 text-green-50">
    <h3 aria-hidden="true" class="relative z-1 mx-auto my-16 w-fit font-headline text-3xl">
      Mest leste <span class="bg-coral-20 py-2">artikler</span>
      <IconsGraphicsMostReadSpinner class="absolute -top-8 -right-12 z-[-1] rotate-on-scroll" aria-hidden="true" />
    </h3>
    <h3 class="sr-only">
      Mest leste artikler
    </h3>

    <UContainer class="flex flex-col flex-wrap gap-8 xs:flex-row xs:gap-0">
      <template v-for="option in LEVEL_OPTIONS" :key="option.value">
        <div
          v-if="mostReadArticles[option.value].length > 0"
          class="overview__column flex flex-1 flex-col"
        >
          <h4 class="p-4 font-normal capitalize sm:p-7">
            {{ option.title }}
          </h4>
          <div
            v-for="article in mostReadArticles[option.value]"
            :key="article.id"
          >
            <CardsArticleSimple :article="article" />
          </div>
        </div>
      </template>
    </UContainer>
  </section>
</template>

<style scoped>
@reference "~/assets/styles/main.css";

.overview__column {
  & > * {
    border-bottom: 1px dotted var(--color-green-50);

    &:nth-child(1) {
      border-top: none;
      border-bottom: 2px solid var(--color-green-50);

      @media screen and (min-width: theme('screens.xs')) {
        margin-top: 0;
      }
    }

    &:nth-child(4) {
      border-bottom: none;
    }
  }

  @media screen and (min-width: theme('screens.xs')) {
    &:not(:last-child) {
      border-right: 1px dotted var(--color-green-50);
    }
  }
}
</style>
